import { withStyles } from '@material-ui/core/styles';
import MuiSelect from '@material-ui/core/Select';
//
import colors from 'theme/colors';

const { white } = colors;

const Select = withStyles({
  root: {
    background: white,
    width: '100%',

    '&:focus': {
      background: white,
      borderRadius: 4,
    },
    '&.MuiOutlinedInput-inputSelect': {
      paddingTop: 15,
      paddingRight: 13,
      paddingBottom: 15,
      paddingLeft: 13,
    },
  },
})(MuiSelect);

export default Select;
